<template>
    <div>
        <p class="overline text-center pt-8" :style='color'> 
            <v-icon small :style='color'>{{icono}}</v-icon>
            {{textoSeparador}}
        </p>
    </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    props: [
        'textoSeparador',
        'icono',
        'color'
    ],
}
</script>